import './TeacherCard.scss'


export default function TeacherCard({name, img, about}){

    return(
        <div className="TeacherCard">
            <div className="wrapper">
                <div className="card_img">
                    <img src={img} alt="teacher-photo" loading="lazy" />
                </div>
                <div className="card_body">
                    <div className="name">{name}</div>
                    <div className="about">{about}</div>
                </div>
            </div>
        </div>
    )
}